"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var x1 = _a.x1,
      x2 = _a.x2;
  return {
    overlay: {
      padding: x2 + "px 0"
    },
    inputWrapper: {
      flex: '1 1 auto'
    },
    chipWrapper: {
      margin: x1 + "px"
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    }
  };
};